import type { PromptRow, TtsHistoryRow } from './types';

/** Parse a "YYYY-MM-DD HH:MM:SS" timestamp to a comparable number. Missing
 *  timestamps sort to the bottom by returning 0 (which is before any real
 *  date when sorting descending). */
function toMs(s: string | undefined): number {
  if (!s) return 0;
  const t = Date.parse(s.replace(' ', 'T'));
  return Number.isFinite(t) ? t : 0;
}

/** Sort prompts most-recent first by upload time, falling back to approval
 *  time, then promptId so two identically-timestamped rows are still stable. */
export function sortPromptsNewestFirst(rows: PromptRow[]): PromptRow[] {
  return [...rows].sort((a, b) => {
    const ta = Math.max(toMs(a.uploadTime), toMs(a.approvalTime));
    const tb = Math.max(toMs(b.uploadTime), toMs(b.approvalTime));
    if (tb !== ta) return tb - ta;
    return b.promptId - a.promptId;
  });
}

/** Sort TTS history rows newest first by `reqDate`. */
export function sortTtsNewestFirst(rows: TtsHistoryRow[]): TtsHistoryRow[] {
  return [...rows].sort((a, b) => {
    const ta = toMs(a.reqDate);
    const tb = toMs(b.reqDate);
    if (tb !== ta) return tb - ta;
    return b.id - a.id;
  });
}
